// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseRestQueryResult as baseQuery } from "@/services/api";
import { ReportIncome, RoomFree, SummaryData } from "@/types/dashboard.type";

interface ReportIncomeGet {
    business_unit_id: string
}

// Define a service using a base URL and expected endpoints
export const dashboardApi = createApi({
    reducerPath: "dashboardApi",
    baseQuery,
    endpoints: (builder) => ({
        getSummary: builder.query<SummaryData, {}>({
            query: (data) => ({ url: `dashboard/summary`, params: data }),
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: SummaryData }, meta) => {
                return rawResult.data
            },
        }),
        getReportIncome: builder.query<ReportIncome[], ReportIncomeGet>({
            query: (data) => ({url: `dashboard/income`, params: data}),
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: ReportIncome[] }, meta) => {
                return rawResult?.data || []
            },
        }),
        getRoomFrees: builder.query<RoomFree[], unknown>({
            query: (data) => ({url: `dashboard/room-free`, params: data}),
            keepUnusedDataFor: 0,
            transformResponse: (rawResult: { data: RoomFree[] }, meta) => {
                return rawResult?.data || []
            },
        }),
    }),
});

export const { useGetSummaryQuery, useGetReportIncomeQuery, useGetRoomFreesQuery } = dashboardApi;
